import {until} from 'lit-html/directives/until';
import {repeat} from 'lit-html/directives/repeat';
import {formLabels} from '@modules/i18n-labels';

const renderChild = (ctx, html, child) => {
  const nameClass = child.linked ? 'student-name disabled' : '';
  let wrapperClass = child.linked ? 'disabled' : 'cursor-pointer';
  let radioClass = child.linked ? 'invisible' : '';
  if (ctx.currentActivation.child_profile_id === child.profile_id) {
    wrapperClass += ' selected';
    radioClass += 'selected';
  }

  return html`
    <div class="d-flex pb-2 ${wrapperClass}" @click=${() => ctx.toggle(child)}>
      <div>
        <span class="radio ${radioClass}"></span>
      </div>
      <div class="name-container">
        <span class="name ${nameClass}">${until(child.name)}</span>
      </div>
    </div>`;
};

export default (ctx, html) => html`
<div class="modal" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header " tabindex="0" focusfirst>${until(ctx.__('<tt-n0n27ygl>', 'Child Selection'))}</div>
      <div class="modal-body w-75 mx-auto py-5">
        <div class="text-dark pb-4">${until(ctx._r(ctx.__('<tt-DoVvvKRn>', 'We found existing children in your account. Please choose the account names to sync with %r1%.'), ctx.currentActivation.student.name))}</div>
        <div class="row border-top-bottom-dotted pt-4 pb-4 align-items-center">
          <div class="col-sm-4 text-center">
            <product-icon class="pb-5" .product="${ctx.currentActivation.products[0]}"></product-icon>
          </div>
          <div class="col-sm-8">
            <div class="">
              ${repeat(ctx.currentActivation.children, (child) => child, (child) => renderChild(ctx, html, child))}
              <div class="d-flex cursor-pointer" @click=${() => ctx.toggle({profile_id: 'new'})}>
                <div>
                  <span class="radio ${ctx.currentActivation.child_profile_id === 'new' ? 'selected' : ''}"></span>
                </div>
                <div class="name-container">
                  <span class="name">${until(ctx.__('<tt-CQGb+Ys+>', 'Add New Child'))}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          focuslast
          type="submit"
          data-bi-id="submit_child_select"
          @click="${ctx.onSubmit}"
          ?disabled="${ctx.disabled}"
          class="btn btn-primary btn-block btn-lg btn-pill btn-submit mt-3 ${ctx.disabled ? 'disabled' : ''}">${until(formLabels.submit)}</button>
        <div class="text-center pt-3">
          <a class="btn btn-link" tabindex="0" href="" @click="${(e) => ctx.onSkip(e)}">${until(ctx.__('<tt-s1GEv89p>', 'Skip'))}</a>
        </div>
      </div>
    </div>
  </div>
</div>
`;
